module.exports = __webpack_public_path__ + "img/state_map.bfed0302.svg";